module.exports = __webpack_public_path__ + "media/assets/user-reviews-a72f78b188e568fff45bbf56fbcd57c4.svg";